import styles from './style.module.css';
export const MENTION_LEGAL: { [key: string]: React.ReactNode } = {
  cetelem: (
    <>
      <h1 className={styles['modal-title']}>Mentions légales</h1>
      <br />
      <p>
        Vous êtes actuellement connecté au site{' '}
        {typeof window !== 'undefined' ? window.origin : ''}qui est édité par
        BNP Paribas Personal Finance (ci-après le « Site »).
        <br /> <br />
        <u>Dénomination sociale</u> : BNP Paribas Personal Finance <br />
        Société Anonyme au capital de 634.574.115 €
        <br />
        <u>Siège social</u> : 1 Boulevard Haussmann – 75009 Paris France
        <br />
        <u>RCS</u> : Paris n°542 097 902
        <br /> <br />
        <u>Numéro de téléphone</u> : +33 (0)1 46 39 99 39
        <br />
        <u>Directeur de la publication</u> : Charlotte DENNERY, Administratrice
        et Directrice Générale
        <br /> <br />
        BNP Paribas Personal Finance est un établissement de crédit de droit
        français agréé en qualité de banque par l’Autorité de Contrôle
        Prudentiel et de Résolution (ACPR - 4 Place de Budapest, CS 92459, 75436
        Paris Cedex 09) et contrôlé par cette même autorité.
        <br />
        BNP Paribas Personal Finance est membre de l’Association Française des
        Sociétés
        <br />
        Financières et de la Fédération Bancaire Française.
        <br /> <br />
        Site conçu et réalisé par BNP Paribas Personal Finance.
        <br />
        Ce site est hébergé sur les serveurs de BNP Paribas Personal Finance.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Présentation du Site</h1>
      <br />
      <p>
        Le Site est uniquement destiné aux partenaires de BNP Paribas Personal
        Finance ayant conclu un accord en vue de la distribution des produits de
        financement de BNP Paribas Personal Finance. Le Site a pour vocation
        d’administrer les comptes utilisateurs de nos partenaires dans
        l’annuaire PING Identity.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Conditions d’accès</h1>
      <br />
      <p>
        L’accès et l’utilisation des services du Site nécessite l’ouverture d’un
        compte utilisateur impliquant la fourniture d’un identifiant et le choix
        d’un mot de passe.
        <br /> <br />
        L’identifiant et le mot de passe sont personnels et confidentiels.
        L’utilisateur en est seul responsable. Il s’engage à ne pas le divulguer
        à des tiers et à prendre toutes les précautions nécessaires pour éviter
        que des tiers ne puissent y avoir accès.
        <br /> <br />
        L’utilisateur s’engage à avertir sans délai BNP Paribas Personal Finance
        en cas de perte ou de vol de son mot de passe et/ou de son identifiant.
        <br /> <br />
        A défaut, et sans preuve contraire toute connexion ou transmission sera
        réputée provenir de l’utilisateur sous sa responsabilité exclusive.
        <br /> <br />
        Les frais d’accès et d’utilisation du réseau de télécommunication sont à
        la charge de l’utilisateur, selon les modalités fixées par ses
        fournisseurs d’accès et opérateurs de télécommunication.
        <br />
        BNP Paribas Personal Finance ne saurait garantir que le fonctionnement
        du Site sera ininterrompu et exempt de toute erreur et ne saurait être
        tenue responsable des éléments en dehors de son contrôle et des dommages
        qui pourraient éventuellement être subis par l’environnement technique
        de l’utilisateur et notamment, ses ordinateurs, logiciels, équipements
        réseaux et tout autre matériel utilisé pour accéder au Site et/ou
        utiliser les informations qui y sont contenues.
        <br />
        De même, sa responsabilité ne saurait être engagée pour des faits dus à
        un cas de force majeure, pour les pannes et les problèmes d’ordre
        technique concernant le matériel, et pour les programmes et logiciels ou
        le réseau internet pouvant, le cas échéant, entraîner la suspension ou
        la cessation du service.
        <br /> <br />
        Il est rappelé que le secret des correspondances privées n’est pas
        garanti sur le réseau Internet. Par ailleurs, il appartient à chaque
        utilisateur d’Internet de prendre toutes les mesures appropriées de
        façon à protéger ses propres données et/ou logiciels de la contamination
        d’éventuels virus circulant sur Internet.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Propriété intellectuelle</h1>
      <br />
      <p>
        Le Site et son contenu sont protégés au titre de la propriété
        intellectuelle, en particulier par les droits d’auteur, de dessins et
        modèles et le droit des marques.
        <br />
        BNP Paribas est titulaire du nom de domaine.
        <br />
        Toute exploitation, reproduction, diffusion ou rediffusion, tout usage,
        qu’ils soient intégraux ou partiels, des créations, marques, logos, et
        de tout autre élément constitutif du Site, par quelque procédé ou
        support que ce soit, sont interdits et constituent, sans l’autorisation
        expresse et préalable de l’éditeur ou de leurs propriétaires, une
        contrefaçon au titre des règles régissant la propriété intellectuelle.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Droit applicable</h1>
      <br />
      <p>
        Le contenu du Site est soumis au droit français.
        <br />
        Tout utilisateur reconnait la compétence des tribunaux français pour
        tout ce qui concerne le contenu et l’utilisation du Site ou les recours
        en découlant.
      </p>
    </>
  ),
  domofinance: (
    <>
      <h1 className={styles['modal-title']}>Mentions légales</h1>
      <br />
      <p>
        Vous êtes actuellement connecté au site{' '}
        {typeof window !== 'undefined' ? window.origin : ''} qui est édité par
        Domofinance (ci-après le « Site »).
        <br /> <br />
        <u>Dénomination sociale :</u> Domofinance <br />
        Société Anonyme au capital de 53.000.010 €
        <br />
        <u>Siège social</u> : 1 Boulevard Haussmann – 75009 Paris France
        <br />
        <u>RCS</u> : Paris n°450 275 490
        <br />
        <u>Numéro de téléphone</u> : 01 55 90 44 60
        <br />
        <u>Directeur de la publication</u> : Claire Courrèges
        <br /> <br />
        Domofinance est une société de financement de droit français agrée par
        l’Autorité de Contrôle Prudentiel et de Résolution (ACPR - 4 Place de
        Budapest, CS 92459, 75436 Paris Cedex 09).
        <br />
        Domofinance est membre de l’Association Française des Sociétés
        Financières.
        <br /> <br />
        Site conçu et réalisé par BNP Paribas Personal Finance.
        <br />
        Ce site est hébergé sur les serveurs de BNP Paribas Personal Finance.
        <br />
        Société Anonyme au capital de 617.279.915 €
        <br />
        <u>Siège social : </u>1 Boulevard Haussmann – 75009 Paris France
        <br />
        <u>RCS</u> : Paris n°542 097 902
      </p>
      <br />
      <h1 className={styles['modal-title']}>Présentation du Site</h1>
      <br />
      <p>
        Le Site est uniquement destiné aux partenaires de Domofinance ayant
        conclu un accord en vue de la distribution des produits de financement
        de Domofinance. Le Site a pour vocation d’administrer les comptes
        utilisateurs de nos partenaires dans l’annuaire PING Identity.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Conditions d’accès</h1>
      <br />
      <p>
        L’accès et l’utilisation des services du Site nécessite l’ouverture d’un
        compte utilisateur impliquant la fourniture d’un identifiant et le choix
        d’un mot de passe.
        <br /> <br />
        L’identifiant et le mot de passe sont personnels et confidentiels.
        L’utilisateur en est seul responsable. Il s’engage à ne pas le divulguer
        à des tiers et à prendre toutes les précautions nécessaires pour éviter
        que des tiers ne puissent y avoir accès.
        <br /> <br />
        L’utilisateur s’engage à avertir sans délai Domofinance en cas de perte
        ou de vol de son mot de passe et/ou de son identifiant.
        <br /> <br />
        A défaut, et sans preuve contraire toute connexion ou transmission sera
        réputée provenir de l’utilisateur sous sa responsabilité exclusive.
        <br /> <br />
        Les frais d’accès et d’utilisation du réseau de télécommunication sont à
        la charge de l’utilisateur, selon les modalités fixées par ses
        fournisseurs d’accès et opérateurs de télécommunication.
        <br />
        Domofinance ne saurait garantir que le fonctionnement du Site sera
        ininterrompu et exempt de toute erreur et ne saurait être tenue
        responsable des éléments en dehors de son contrôle et des dommages qui
        pourraient éventuellement être subis par l’environnement technique de
        l’utilisateur et notamment, ses ordinateurs, logiciels, équipements
        réseaux et tout autre matériel utilisé pour accéder au Site et/ou
        utiliser les informations qui y sont contenues.
        <br />
        De même, sa responsabilité ne saurait être engagée pour des faits dus à
        un cas de force majeure, pour les pannes et les problèmes d’ordre
        technique concernant le matériel, et pour les programmes et logiciels ou
        le réseau internet pouvant, le cas échéant, entraîner la suspension ou
        la cessation du service.
        <br /> <br />
        Il est rappelé que le secret des correspondances privées n’est pas
        garanti sur le réseau Internet. Par ailleurs, il appartient à chaque
        utilisateur d’Internet de prendre toutes les mesures appropriées de
        façon à protéger ses propres données et/ou logiciels de la contamination
        d’éventuels virus circulant sur Internet.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Propriété intellectuelle</h1>
      <br />
      <p>
        Le Site et son contenu sont protégés au titre de la propriété
        intellectuelle, en particulier par les droits d’auteur, de dessins et
        modèles et le droit des marques.
        <br />
        BNP Paribas est titulaire du nom de domaine.
        <br />
        Toute exploitation, reproduction, diffusion ou rediffusion, tout usage,
        qu’ils soient intégraux ou partiels, des créations, marques, logos, et
        de tout autre élément constitutif du Site, par quelque procédé ou
        support que ce soit, sont interdits et constituent, sans l’autorisation
        expresse et préalable de l’éditeur ou de leurs propriétaires, une
        contrefaçon au titre des règles régissant la propriété intellectuelle.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Droit applicable</h1>
      <br />
      <p>
        Le contenu du Site est soumis au droit français.
        <br />
        Tout utilisateur reconnait la compétence des tribunaux français pour
        tout ce qui concerne le contenu et l’utilisation du Site ou les recours
        en découlant.
      </p>
    </>
  ),
  cafineo: (
    <>
      <h1 className={styles['modal-title']}>Mentions légales</h1>
      <br />
      <p>
        Vous êtes actuellement connecté au site{' '}
        {typeof window !== 'undefined' ? window.origin : ''} qui est édité par
        Cafineo (ci-après le « Site »).
        <br /> <br />
        <u>Dénomination sociale</u> : Cafineo <br />
        Société Anonyme au capital de 8.295.000 €
        <br />
        <u>Siège social</u> : Rue René Rabat, ZI Jarry, 97122 Baie-Mahault
        <br />
        <u>RCS</u> : RCS Pointe-à-Pitre 501 103 337
        <br />
        <u>Numéro de téléphone</u> : 05 90 60 67 20
        <br />
        <u>Directeur de la publication</u> : Ghislain Duville
        <br /> <br />
        Cafineo est une société de financement de droit français agréée par
        l’autorité de contrôle Prudentiel et de Résolution (ACPR - 4 Place de
        Budapest, CS 92459, 75436 Paris Cedex 09) et contrôlée par cette même
        autorité.
        <br /> <br />
        Code TVA : FR 75 341 891 653
        <br /> <br />
        Cafineo est membre de l’Association Française des Sociétés Financières.
        <br /> <br />
        Ce site est hébergé sur les serveurs de BNP Paribas Personal Finance.
        <br />
        Société Anonyme au capital de 617.279.915 €
        <br />
        <u>Siège social : </u>1 Boulevard Haussmann – 75009 Paris France
        <br />
        <u>RCS</u> : Paris n°542 097 902
      </p>
      <br />
      <h1 className={styles['modal-title']}>Présentation du Site</h1>
      <br />
      <p>
        Le Site est uniquement destiné aux partenaires de Cafineo ayant conclu
        un accord en vue de la distribution des produits de financement de
        Cafineo . Le Site a pour vocation d’administrer les comptes utilisateurs
        de nos partenaires dans l’annuaire PING Identity.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Conditions d’accès</h1>
      <br />
      <p>
        L’accès et l’utilisation des services du Site nécessite l’ouverture d’un
        compte utilisateur impliquant la fourniture d’un identifiant et le choix
        d’un mot de passe.
        <br /> <br />
        L’identifiant et le mot de passe sont personnels et confidentiels.
        L’utilisateur en est seul responsable. Il s’engage à ne pas le divulguer
        à des tiers et à prendre toutes les précautions nécessaires pour éviter
        que des tiers ne puissent y avoir accès.
        <br /> <br />
        L’utilisateur s’engage à avertir sans délai Cafineo en cas de perte ou
        de vol de son mot de passe et/ou de son identifiant.
        <br /> <br />
        A défaut, et sans preuve contraire toute connexion ou transmission sera
        réputée provenir de l’utilisateur sous sa responsabilité exclusive.
        <br /> <br />
        Les frais d’accès et d’utilisation du réseau de télécommunication sont à
        la charge de l’utilisateur, selon les modalités fixées par ses
        fournisseurs d’accès et opérateurs de télécommunication.
        <br />
        Cafineo ne saurait garantir que le fonctionnement du Site sera
        ininterrompu et exempt de toute erreur et ne saurait être tenue
        responsable des éléments en dehors de son contrôle et des dommages qui
        pourraient éventuellement être subis par l’environnement technique de
        l’utilisateur et notamment, ses ordinateurs, logiciels, équipements
        réseaux et tout autre matériel utilisé pour accéder au Site et/ou
        utiliser les informations qui y sont contenues.
        <br />
        De même, sa responsabilité ne saurait être engagée pour des faits dus à
        un cas de force majeure, pour les pannes et les problèmes d’ordre
        technique concernant le matériel, et Classification : Internal pour les
        programmes et logiciels ou le réseau internet pouvant, le cas échéant,
        entraîner la suspension ou la cessation du service.
        <br /> <br />
        Il est rappelé que le secret des correspondances privées n’est pas
        garanti sur le réseau Internet. Par ailleurs, il appartient à chaque
        utilisateur d’Internet de prendre toutes les mesures appropriées de
        façon à protéger ses propres données et/ou logiciels de la contamination
        d’éventuels virus circulant sur Internet.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Propriété intellectuelle</h1>
      <br />
      <p>
        Le Site et son contenu sont protégés au titre de la propriété
        intellectuelle, en particulier par les droits d’auteur, de dessins et
        modèles et le droit des marques.
        <br />
        BNP Paribas est titulaire du nom de domaine.
        <br />
        Toute exploitation, reproduction, diffusion ou rediffusion, tout usage,
        qu’ils soient intégraux ou partiels, des créations, marques, logos, et
        de tout autre élément constitutif du Site, par quelque procédé ou
        support que ce soit, sont interdits et constituent, sans l’autorisation
        expresse et préalable de l’éditeur ou de leurs propriétaires, une
        contrefaçon au titre des règles régissant la propriété intellectuelle.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Droit applicable</h1>
      <br />
      <p>
        Le contenu du Site est soumis au droit français.
        <br />
        Tout utilisateur reconnait la compétence des tribunaux français pour
        tout ce qui concerne le contenu et l’utilisation du Site ou les recours
        en découlant.
      </p>
    </>
  ),
  cmoi: (
    <>
      <h1 className={styles['modal-title']}>Mentions légales</h1>
      <br />
      <p>
        Vous êtes actuellement connecté au site{' '}
        {typeof window !== 'undefined' ? window.origin : ''} qui est édité par
        Crédit Moderne Océan Indien (ci-après le « Site »).
        <br /> <br />
        <u>Dénomination sociale</u> : Crédit Moderne Océan Indien <br />
        Société Anonyme au capital 4.575.776 €
        <br />
        <u>Siège social</u> : 28 rue Lislet Geoffroy CS 91028 - 97495 Sainte
        Clotilde Cedex
        <br />
        <u>RCS</u> : RCS Saint Denis n°333 353 944
        <br />
        <u>Numéro de téléphone</u> : 02 62 92 39 24
        <br />
        <u>Directeur de la publication</u> : Najib GHARIB
        <br /> <br />
        Crédit Moderne Océan Indien est une société de financement de droit
        français agréée par l’autorité de contrôle Prudentiel et de Résolution
        (ACPR - 4 Place de Budapest, CS 92459, 75436 Paris Cedex 09) et
        contrôlée par cette même autorité.
        <br /> <br />
        Crédit Moderne Océan Indien est membre de l’Association Française des
        Sociétés Financières.
        <br /> <br />
        Site conçu et réalisé par BNP Paribas Personal Finance.
        <br></br>
        Ce site est hébergé sur les serveurs de BNP Paribas Personal Finance.
        <br />
        Société Anonyme au capital de 617.279.915 €
        <br />
        <u>Siège social : </u>1 Boulevard Haussmann – 75009 Paris France
        <br />
        <u>RCS</u> : Paris n°542 097 902
      </p>
      <br />
      <h1 className={styles['modal-title']}>Présentation du Site</h1>
      <br />
      <p>
        Le Site est uniquement destiné aux partenaires de Crédit Moderne Océan
        Indien ayant conclu un accord en vue de la distribution des produits de
        financement de Crédit Moderne Océan Indien. Le Site a pour vocation
        d’administrer les comptes utilisateurs de nos partenaires dans
        l’annuaire PING Identity.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Conditions d’accès</h1>
      <br />
      <p>
        L’accès et l’utilisation des services du Site nécessite l’ouverture d’un
        compte utilisateur impliquant la fourniture d’un identifiant et le choix
        d’un mot de passe.
        <br /> <br />
        L’identifiant et le mot de passe sont personnels et confidentiels.
        L’utilisateur en est seul responsable. Il s’engage à ne pas le divulguer
        à des tiers et à prendre toutes les précautions nécessaires pour éviter
        que des tiers ne puissent y avoir accès.
        <br /> <br />
        L’utilisateur s’engage à avertir sans délai Crédit Moderne Océan Indien
        en cas de perte ou de vol de son mot de passe et/ou de son identifiant.
        <br /> <br />
        A défaut, et sans preuve contraire toute connexion ou transmission sera
        réputée provenir de l’utilisateur sous sa responsabilité exclusive.
        <br /> <br />
        Les frais d’accès et d’utilisation du réseau de télécommunication sont à
        la charge de l’utilisateur, selon les modalités fixées par ses
        fournisseurs d’accès et opérateurs de télécommunication.
        <br />
        Crédit Moderne Océan Indien ne saurait garantir que le fonctionnement du
        Site sera ininterrompu et exempt de toute erreur et ne saurait être
        tenue responsable des éléments en dehors de son contrôle et des dommages
        qui pourraient éventuellement être subis par l’environnement technique
        de l’utilisateur et notamment, ses ordinateurs, logiciels, équipements
        réseaux et tout autre matériel utilisé pour accéder au Site et/ou
        utiliser les informations qui y sont contenues.
        <br />
        De même, sa responsabilité ne saurait être engagée pour des faits dus à
        un cas de force majeure, pour les pannes et les problèmes d’ordre
        technique concernant le matériel, et pour les programmes et logiciels ou
        le réseau internet pouvant, le cas échéant, entraîner la suspension ou
        la cessation du service.
        <br /> <br />
        Il est rappelé que le secret des correspondances privées n’est pas
        garanti sur le réseau Internet. Par ailleurs, il appartient à chaque
        utilisateur d’Internet de prendre toutes les mesures appropriées de
        façon à protéger ses propres données et/ou logiciels de la contamination
        d’éventuels virus circulant sur Internet.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Propriété intellectuelle</h1>
      <br />
      <p>
        Le Site et son contenu sont protégés au titre de la propriété
        intellectuelle, en particulier par les droits d’auteur, de dessins et
        modèles et le droit des marques.
        <br />
        BNP Paribas est titulaire du nom de domaine.
        <br />
        Toute exploitation, reproduction, diffusion ou rediffusion, tout usage,
        qu’ils soient intégraux ou partiels, des créations, marques, logos, et
        de tout autre élément constitutif du Site, par quelque procédé ou
        support que ce soit, sont interdits et constituent, sans l’autorisation
        expresse et préalable de l’éditeur ou de leurs propriétaires, une
        contrefaçon au titre des règles régissant la propriété intellectuelle.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Droit applicable</h1>
      <br />
      <p>
        Le contenu du Site est soumis au droit français.
        <br />
        Tout utilisateur reconnait la compétence des tribunaux français pour
        tout ce qui concerne le contenu et l’utilisation du Site ou les recours
        en découlant.
      </p>
    </>
  ),
  cmag: (
    <>
      <h1 className={styles['modal-title']}>Mentions légales</h1>
      <br />
      <p>
        Vous êtes actuellement connecté au site{' '}
        {typeof window !== 'undefined' ? window.origin : ''} qui est édité par
        Crédit Moderne Antilles Guyane (ci-après le « Site »).
        <br /> <br />
        <u>Dénomination sociale</u> : Crédit Moderne Antilles Guyane <br />
        Société Anonyme au capital 18.727.232 €
        <br />
        <u>Siège social</u> : Immeuble Le Semaphore - rue René Rabat ZAC de
        Houëlbourg Sud II Z.I. de Jarry - 97122 Baie-Mahault Cedex.
        <br />
        <u>RCS</u> : RCS Pointe à Pitre n°341 891 653
        <br />
        <u>Numéro de téléphone</u> : 05 90 32 60 62
        <br />
        <u>Directeur de la publication</u> : Laurent Claudel
        <br /> <br />
        Crédit Moderne Antilles Guyane est une société de financement de droit
        français agréée par l’autorité de contrôle Prudentiel et de Résolution
        (ACPR - 4 Place de Budapest, CS 92459, 75436 Paris Cedex 09) et
        contrôlée par cette même autorité.
        <br /> <br />
        Crédit Moderne Antilles Guyane est membre de l’Association Française des
        Sociétés Financières.
        <br /> <br />
        Site conçu et réalisé par BNP Paribas Personal Finance.
        <br></br>
        Ce site est hébergé sur les serveurs de BNP Paribas Personal Finance.
        <br />
        Société Anonyme au capital de 617.279.915 €
        <br />
        <u>Siège social</u> : 1 Boulevard Haussmann – 75009 Paris France
        <br />
        <u>RCS</u> : Paris n°542 097 902
      </p>
      <br />
      <h1 className={styles['modal-title']}>Présentation du Site</h1>
      <br />
      <p>
        Le Site est uniquement destiné aux partenaires de Crédit Moderne ayant
        conclu un accord en vue de la distribution des produits de financement
        de Crédit Moderne Antilles Guyane. Le Site a pour vocation d’administrer
        les comptes utilisateurs de nos partenaires dans l’annuaire PING
        Identity.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Conditions d’accès</h1>
      <br />
      <p>
        L’accès et l’utilisation des services du Site nécessite l’ouverture d’un
        compte utilisateur impliquant la fourniture d’un identifiant et le choix
        d’un mot de passe.
        <br /> <br />
        L’identifiant et le mot de passe sont personnels et confidentiels.
        L’utilisateur en est seul responsable. Il s’engage à ne pas le divulguer
        à des tiers et à prendre toutes les précautions nécessaires pour éviter
        que des tiers ne puissent y avoir accès.
        <br /> <br />
        L’utilisateur s’engage à avertir sans délai Crédit Moderne Antilles
        Guyane en cas de perte ou de vol de son mot de passe et/ou de son
        identifiant.
        <br /> <br />
        A défaut, et sans preuve contraire toute connexion ou transmission sera
        réputée provenir de l’utilisateur sous sa responsabilité exclusive.
        <br /> <br />
        Les frais d’accès et d’utilisation du réseau de télécommunication sont à
        la charge de l’utilisateur, selon les modalités fixées par ses
        fournisseurs d’accès et opérateurs de télécommunication.
        <br /> <br />
        Crédit Moderne Antilles Guyane ne saurait garantir que le fonctionnement
        du Site sera ininterrompu et exempt de toute erreur et ne saurait être
        tenue responsable des éléments en dehors de son contrôle et des dommages
        qui pourraient éventuellement être subis par l’environnement technique
        de l’utilisateur et notamment, ses ordinateurs, logiciels, équipements
        réseaux et tout autre matériel utilisé pour accéder au Site et/ou
        utiliser les informations qui y sont contenues.
        <br />
        De même, sa responsabilité ne saurait être engagée pour des faits dus à
        un cas de force majeure, pour les pannes et les problèmes d’ordre
        technique concernant le matériel, et Classification : Internal pour les
        programmes et logiciels ou le réseau internet pouvant, le cas échéant,
        entraîner la suspension ou la cessation du service.
        <br /> <br />
        Il est rappelé que le secret des correspondances privées n’est pas
        garanti sur le réseau Internet. Par ailleurs, il appartient à chaque
        utilisateur d’Internet de prendre toutes les mesures appropriées de
        façon à protéger ses propres données et/ou logiciels de la contamination
        d’éventuels virus circulant sur Internet.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Propriété intellectuelle</h1>
      <br />
      <p>
        Le Site et son contenu sont protégés au titre de la propriété
        intellectuelle, en particulier par les droits d’auteur, de dessins et
        modèles et le droit des marques.
        <br />
        BNP Paribas est titulaire du nom de domaine.
        <br />
        Toute exploitation, reproduction, diffusion ou rediffusion, tout usage,
        qu’ils soient intégraux ou partiels, des créations, marques, logos, et
        de tout autre élément constitutif du Site, par quelque procédé ou
        support que ce soit, sont interdits et constituent, sans l’autorisation
        expresse et préalable de l’éditeur ou de leurs propriétaires, une
        contrefaçon au titre des règles régissant la propriété intellectuelle.
      </p>
      <br />
      <h1 className={styles['modal-title']}>Droit applicable</h1>
      <br />
      <p>
        Le contenu du Site est soumis au droit français.
        <br />
        Tout utilisateur reconnait la compétence des tribunaux français pour
        tout ce qui concerne le contenu et l’utilisation du Site ou les recours
        en découlant.
      </p>
    </>
  ),
};
export const COOKIES = (
  <>
    <h2 className={styles['modal-title']}>Politique cookies</h2>
    <br />
    <p>
      Le Groupe BNP Paribas est particulièrement attentif à vous délivrer le
      meilleur service possible et nous souhaitons préserver la confiance que
      vous nous témoignez.Dans ce cadre, nous avons adopté des principes forts
      afin d’assurer la protection de vos données.
      <br />
      C&apos;est pourquoi nous souhaitons vous fournir des informations
      transparentes sur la manière dont nous plaçons, utilisons et stockons des
      cookies sur votre appareil lorsque vous consultez nos sites ou
      applications (ci-après le « Site » portail-outils-partenaires.fr) et vous
      présentez les options qui vous permettent de les gérer et les supprimer.
    </p>
    <br />
    <h1 className={styles['modal-title']}>1. Qu’est-ce qu’un cookie?</h1>
    <br />
    <p>
      Les cookies sont de petits fichiers texte, image ou logiciel qui peuvent
      être déposés et/ou lus sur votre appareil lorsque vous accédez à notre
      Site. Le mot « appareil », lorsqu&apos;il est utilisé dans la présente
      Politique Cookies, désigne notamment les ordinateurs, les téléphones
      intelligents, les tablettes et tout autre appareil utilisé pour accéder à
      Internet.Les cookies peuvent être (i) de session, ce qui signifie qu’ils
      sont supprimés de votre terminal une fois la session et le navigateur
      fermés ; ou (ii) persistants, ce qui signifie qu’ils seront stockés sur
      votre terminal jusqu’à leur suppression.
    </p>
    <br />
    <h1 className={styles['modal-title']}>
      2. Quels types d’information peuvent être stockés dans un cookie?
    </h1>
    <br />
    <p>
      Les informations stockées par les cookies déposés sur votre appareil
      peuvent avoir trait aux éléments suivants, dans la limite de leur durée de
      conservation :
      <br />
      - Les pages web que vous avez visitées en utilisant cet appareil ;<br />-
      Les publicités sur lesquelles vous avez cliqué ;<br />- Le type de
      navigateur que vous utilisez ;<br />- Votre adresse IP;
      <br />- Et toute autre information que vous avez fournie sur notre
      Site/Application.
      <br />
      Les cookies peuvent contenir des données à caractère personnel couvertes
      par notre Notice de Protection des Données
    </p>
    <br />
    <h1 className={styles['modal-title']}>
      3. Quel type de cookies utilisons nous ? Est-il possible de refuser
      l’installation de ces cookies ?
    </h1>
    <br />
    <p>
      Les cookies que nous utilisons sur ce Site sont exclusivement des cookies
      qui ont pour seul but de permettre ou faciliter la communication par voie
      électronique ou qui sont strictement nécessaires au fonctionnement du
      Site.
      <br />
      Par exemple, les cookies strictement nécessaires que nous utilisons sur ce
      Site peuvent notamment nous permettre de :
      <br />
      <br />
      <b>- Vous authentifier et vous identifier</b> sur notre Site afin de vous
      fournir les services que vous avez demandés ;
      <br />
      <b>- Améliorer la sécurité du Site</b> y compris par la prévention de
      l’usage frauduleux d’identifiants de connexion et la protection des
      données utilisateurs de l’accès par des tiers non autorisés (par exemple
      en limitant les tentatives d’accès robotisé ou inattendues) ;
      <br />
      <b>- Suivre votre manière d’utiliser notre Site afin de l’améliorer</b>,
      par exemple en optimisant ses performances techniques ou son ergonomie ;
      <br />
      <b>- Enregistrer vos préférences</b> et vos paramètres d&apos;utilisation
      de notre Site (par exemple langue, fuseau horaire, etc.).
      <br />
      <br />
      L’utilisation des cookies strictement nécessaires au bon fonctionnement du
      Site ne requiert pas votre consentement. C’est pourquoi aucun module de
      gestion de vos préférences en matière de cookies n’est disponible sur ce
      Site
    </p>
  </>
);
